import { userInfo } from './UserInfoReducer'

const Reducers = {
  userInfo,
}

export { Reducers }
